import {
  addNewUserFetch,
  getRoleUserListFetch,
  modifyPassword,
  logoutFetch,
  getAllPermRole,
  getAlluserRole,
  modifyUserManageFetch,
  modifyPermsManageFetch,
  editUserFetch,
  addroleManageFetch,
  getRoleInfoListFetch,
  modifyPermsRoleFetch,
  editPermsRoleFetch,
  getAllUserExpAdminFetch,
  getAppBypageFetch,
  changeALlPermFetch,
  changePermFetch,
  delUserFetch,
  delRoleFetch,
} from "../../api/api";
const state = {
  roleUserList: [],
  userRoleList: [],
  permsRoleList: [],
  roleInfo: [],
  roleMaxId: "",
  allUserExpAdminList: [],
  appsList: [],
  appTotal: 0,
  userCount: 0,
  roleCount: 0,
  appCurrentPage: 1,
  userCurrentPage: 1,
  roleCurrentPage: 1,
};

const actions = {
  async addNewUser({ commit }, { param, cb }) {
    try {
      const data = await addNewUserFetch(param);
      cb(data);
      commit("");
    } catch (e) {
      throw new Error(e);
    }
  },
  async editUser({ commit }, { param, cb }) {
    try {
      const data = await editUserFetch(param);
      cb(data);
      commit("");
    } catch (e) {
      throw new Error(e);
    }
  },
  async getRoleUserList({ commit }, { param, cb }) {
    try {
      const data = await getRoleUserListFetch(param);
      const user = await getAlluserRole();
      const perms = await getAllPermRole();
      Promise.all([data, user, perms]).then((result) => {
        commit("setRoleUserList", result);
        cb();
      });
    } catch (e) {
      throw new Error(e);
    }
  },
  async modifyPass({ commit }, { param, cb }) {
    try {
      const data = await modifyPassword(param);
      commit("");
      cb(data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async logout({ commit }, cb) {
    try {
      const data = await logoutFetch();
      commit("");
      cb(data.code);
    } catch (e) {
      throw new Error(e);
    }
  },
  async modifyUserManage({ commit }, { param, cb }) {
    try {
      const data = await modifyUserManageFetch(param);
      commit("");
      cb(data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async modifyPermsManage({ commit }, { param, cb }) {
    try {
      const data = await modifyPermsManageFetch(param);
      commit("");
      cb(data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async modifyPermsRole({ commit }, { param, cb }) {
    try {
      const data = await modifyPermsRoleFetch(param);
      commit("");
      cb(data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async addroleManage({ commit }, { param, cb }) {
    try {
      const data = await addroleManageFetch(param);
      commit("");
      cb(data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async editPermsRole({ commit }, { param, cb }) {
    try {
      const data = await editPermsRoleFetch(param);
      commit("");
      cb(data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async getRoleInfoList({ commit }, { param, cb }) {
    try {
      const data = await getRoleInfoListFetch(param);
      const perms = await getAllPermRole();
      Promise.all([data, perms]).then((result) => {
        commit("setRoleInfoList", result);
        cb();
      });
    } catch (e) {
      throw new Error(e);
    }
  },
  async getAllUserExpAdmin({ commit }, cb) {
    try {
      const data = await getAllUserExpAdminFetch();
      cb(data);
      commit("setAllUserExpAdminList", data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async getAppBypage({ commit }, { param, cb }) {
    try {
      const data = await getAppBypageFetch(param);
      // cb(data)
      data.appList.map((v) => {
        v.ifChosen ? (v.ifChosen = true) : (v.ifChosen = false);
      });
      cb();
      commit("setAppBypage", data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async changeALlPerm({ commit }, { param, cb }) {
    try {
      const data = await changeALlPermFetch(param);
      cb(data);
      commit("");
    } catch (e) {
      throw new Error(e);
    }
  },
  async changePerm({ commit }, { param, cb }) {
    try {
      const data = await changePermFetch(param);
      cb(data);
      commit("");
    } catch (e) {
      throw new Error(e);
    }
  },
  async delUser({ commit }, { param, cb }) {
    try {
      const data = await delUserFetch(param);
      cb(data);
      commit("");
    } catch (e) {
      throw new Error(e);
    }
  },
  async delRole({ commit }, { param, cb }) {
    try {
      const data = await delRoleFetch(param);
      cb(data);
      commit("");
    } catch (e) {
      throw new Error(e);
    }
  },
  getcurrentPage({ commit }, param) {
    try {
      commit("setcurrentPage", param);
    } catch (e) {
      throw new Error(e);
    }
  },
  getuserCurrentPage({ commit }, param) {
    try {
      commit("setuserCurrentPage", param);
    } catch (e) {
      throw new Error(e);
    }
  },
  getroleCurrentPage({ commit }, param) {
    try {
      commit("setroleCurrentPage", param);
    } catch (e) {
      throw new Error(e);
    }
  },
};

const mutations = {
  setRoleUserList(state, data) {
    state.roleUserList = data[0].pageUserInfo;
    state.userCount = data[0].userCount;
    state.userRoleList = data[1].pageRoleInfo;
    state.permsRoleList = data[2].permList;
  },
  setRoleInfoList(state, data) {
    state.roleInfo = data[0].pageRoleInfo;
    state.roleCount = data[0].roleCount;
    state.roleMaxId = data[0].maxId;
    state.permsRoleList = data[1].permList;
  },
  setAllUserExpAdminList(state, data) {
    state.allUserExpAdminList = data.userList;
  },
  setAppBypage(state, data) {
    state.appsList = data.appList;
    state.appTotal = data.total;
  },
  setcurrentPage(stata, data) {
    stata.appCurrentPage = data;
  },
  setuserCurrentPage(stata, data) {
    stata.userCurrentPage = data;
  },
  setroleCurrentPage(stata, data) {
    stata.roleCurrentPage = data;
  },
};

export default {
  state,
  actions,
  mutations,
};
